import './styles/index.scss';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode, Suspense } from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import { installDomMutationGuard } from './utils/DomMutationGuard';

installDomMutationGuard();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 20,
      retry: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Suspense fallback={<span>Loading...</span>}>
          <App />
        </Suspense>
      </LocalizationProvider>
    </QueryClientProvider>
  </StrictMode>,
);
